export const footer = {
  paddingTop: '60px'
};
